import { SimNaoEnum } from 'components/form'

import { isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta14Model,
  ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum,
} from './model-consultaSeguimentoPergunta14'

const consultaSeguimentoPergunta14OlhaSeusOlhosEnumValues = Object.values(ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum)

export function isPergunta14OlhaSeusOlhosAllFilled(
  value: ConsultaSeguimentoPergunta14Model['PERGUNTA_14_OLHA_SEUS_OLHOS']
): boolean {
  return isAllFilled(value, consultaSeguimentoPergunta14OlhaSeusOlhosEnumValues)
}

export function hasPergunta14OlhaSeusOlhosAtLeastTwoSim(
  value: ConsultaSeguimentoPergunta14Model['PERGUNTA_14_OLHA_SEUS_OLHOS']
): boolean {
  return Object.values(value ?? {}).filter((item) => item === SimNaoEnum.SIM).length >= 2
}

export const isPergunta14OlhaSeusOlhosAllNao = (
  value: ConsultaSeguimentoPergunta14Model['PERGUNTA_14_OLHA_SEUS_OLHOS']
): boolean => {
  return isAllNao(value, consultaSeguimentoPergunta14OlhaSeusOlhosEnumValues)
}

export function prunePergunta14(value: ConsultaSeguimentoPergunta14Model): ConsultaSeguimentoPergunta14Model {
  const pruned: ConsultaSeguimentoPergunta14Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_14_HEADER: value.PERGUNTA_14_HEADER,
  }

  const isHeaderSim = value.PERGUNTA_14_HEADER === SimNaoEnum.SIM
  const isHeaderNao = value.PERGUNTA_14_HEADER === SimNaoEnum.NAO
  const isDeuExemploAbaixoNao = value.PERGUNTA_14_DEU_EXEMPLO_ABAIXO === SimNaoEnum.NAO
  const hasOlhaSeusOlhosAtLeastTwoSim = hasPergunta14OlhaSeusOlhosAtLeastTwoSim(value.PERGUNTA_14_OLHA_SEUS_OLHOS)
  const isOlhaSeusOlhosAllNao = isPergunta14OlhaSeusOlhosAllNao(value.PERGUNTA_14_OLHA_SEUS_OLHOS)
  const isOlhaSeusOlhosTodosDiasSim = value.PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS === SimNaoEnum.SIM

  const shouldShowOlhaSeusOlhosPath = isHeaderNao || (isHeaderSim && isDeuExemploAbaixoNao)
  const shouldShowOlhaSeusOlhosTodosDias = !hasOlhaSeusOlhosAtLeastTwoSim && !isOlhaSeusOlhosAllNao

  if (isHeaderSim) {
    pruned.PERGUNTA_14_DEU_EXEMPLO_ABAIXO = value.PERGUNTA_14_DEU_EXEMPLO_ABAIXO
  }

  if (shouldShowOlhaSeusOlhosPath) {
    pruned.PERGUNTA_14_OLHA_SEUS_OLHOS = value.PERGUNTA_14_OLHA_SEUS_OLHOS
  }

  if (shouldShowOlhaSeusOlhosPath && shouldShowOlhaSeusOlhosTodosDias) {
    pruned.PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS = value.PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS
  }

  if (shouldShowOlhaSeusOlhosPath && shouldShowOlhaSeusOlhosTodosDias && isOlhaSeusOlhosTodosDiasSim) {
    pruned.PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES = value.PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES
  }

  return pruned
}
